/**
 * @typedef {number} EventStatus
 */

//-----------------------------------------------------------------------------

/** @type {EventStatus} */
export const EVENT_STATUS__INCOMING = 1;

/** @type {EventStatus} */
export const EVENT_STATUS__ACTIVE   = 2;

/** @type {EventStatus} */
export const EVENT_STATUS___ENDED   = 3;

//-----------------------------------------------------------------------------

// options for component b-form-select
export function getEventStatusOptionsForFilter() {
  return [
    {value: null,                   text: 'any'     },
    {value: EVENT_STATUS__INCOMING, text: 'incoming'},
    {value: EVENT_STATUS__ACTIVE,   text: 'active'  },
    {value: EVENT_STATUS___ENDED,   text: 'ended'   },
  ];
}
